import FooterCTA from "@/components/landing/FooterCTA";
import Navbar from "@/components/landing/Navbar";
import StarsBackground from "@/components/landing/StarsBackground";

const Terms = () => (
  <div className="min-h-screen bg-background relative">
    <StarsBackground />
    <div className="relative z-10">
      <Navbar />

      <section className="pt-24 pb-8 md:pt-28 md:pb-12">
        <div className="container-narrow text-center">
          <p className="text-xs font-medium uppercase tracking-widest text-accent mb-2">
            Terms of Use
          </p>
          <p className="text-sm text-muted-foreground">Effective September 2, 2026</p>
        </div>
      </section>

      <section className="py-8 md:py-12">
        <div className="container-narrow max-w-3xl">
          <div className="surface-card p-6 md:p-8 space-y-6 body-md text-muted-foreground prose prose-invert prose-sm max-w-none">
            <p>
              These Terms of Use govern your access to antatlas.ai and AntAtlas services. By accessing or
              using the service, you agree to these Terms. If you use the service for an organization, you
              represent that you have authority to bind that organization.
            </p>

            <h2 className="heading-md text-foreground pt-4">Company</h2>
            <p>The service is provided by AntAtlas, Inc., a Delaware corporation.</p>
            <p>
              Contact: <a href="mailto:support@antatlas.ai">support@antatlas.ai</a>
            </p>

            <h2 className="heading-md text-foreground pt-4">Eligibility</h2>
            <p>
              You must be at least 18 years old and legally able to enter into a contract. The service is
              intended for professional and business use.
            </p>

            <h2 className="heading-md text-foreground pt-4">Waitlist and early access</h2>
            <p>
              Joining the waitlist does not guarantee access, availability, timing, features, or pricing.
              Early-access functionality may change, be suspended, or be discontinued at any time.
              Additional terms may apply before you receive access to paid or private features.
            </p>

            <h2 className="heading-md text-foreground pt-4">Acceptable use</h2>
            <p>You may not:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>use the service unlawfully or infringe another person&apos;s rights;</li>
              <li>attempt to bypass security, access restrictions, or usage limits;</li>
              <li>interfere with or disrupt the service or its infrastructure;</li>
              <li>introduce malicious code or use the service to distribute harmful content;</li>
              <li>reverse engineer the service except where applicable law expressly permits it; or</li>
              <li>misrepresent your identity or authority to act for an organization.</li>
            </ul>

            <h2 className="heading-md text-foreground pt-4">Your code and data</h2>
            <p>
              You retain all rights in your code and repository data. AntAtlas does not store source code
              or repository data, and system graphs are generated and stored on the client side. You are
              responsible for ensuring that you have the rights and permissions needed to process any data
              you use with the service.
            </p>

            <h2 className="heading-md text-foreground pt-4">AntAtlas intellectual property</h2>
            <p>
              AntAtlas and its software, design, branding, and content are owned by AntAtlas, Inc. or its
              licensors and are protected by applicable intellectual-property laws. These Terms give you
              no ownership rights in the service.
            </p>

            <h2 className="heading-md text-foreground pt-4">Feedback</h2>
            <p>
              If you provide feedback, you grant AntAtlas, Inc. a worldwide, perpetual, irrevocable,
              royalty-free right to use it to operate and improve the service without obligation to you.
            </p>

            <h2 className="heading-md text-foreground pt-4">Third-party services</h2>
            <p>
              The service may interoperate with third-party tools. Their terms and privacy policies govern
              your use of those tools. AntAtlas is not responsible for third-party services.
            </p>

            <h2 className="heading-md text-foreground pt-4">Disclaimers</h2>
            <p>
              To the maximum extent permitted by law, the service is provided “as is” and “as available,”
              without warranties of any kind, express or implied. AntAtlas does not warrant that generated
              models, graphs, context, or other outputs are complete or error-free. You are responsible for
              reviewing outputs before relying on them or making changes to software systems.
            </p>

            <h2 className="heading-md text-foreground pt-4">Limitation of liability</h2>
            <p>
              To the maximum extent permitted by law, AntAtlas, Inc. and its affiliates will not be liable
              for indirect, incidental, special, consequential, exemplary, or punitive damages, or for lost
              profits, revenues, data, goodwill, or business interruption arising from the service.
            </p>
            <p>
              AntAtlas, Inc.&apos;s total liability for all claims arising from the service will not exceed the
              greater of US $100 or the amount you paid AntAtlas for the service during the 12 months before
              the event giving rise to the claim. Nothing in these Terms excludes liability that cannot be
              excluded under applicable law.
            </p>

            <h2 className="heading-md text-foreground pt-4">Suspension and termination</h2>
            <p>
              You may stop using the service at any time. We may suspend or terminate access if you violate
              these Terms, create risk or legal exposure, or if we discontinue the service. Provisions that
              by their nature should survive termination will remain in effect.
            </p>

            <h2 className="heading-md text-foreground pt-4">Governing law</h2>
            <p>
              These Terms are governed by the laws of the State of Delaware, without regard to conflict-of-law
              rules. Except where applicable law requires otherwise, disputes will be brought exclusively in
              the state or federal courts located in Delaware, and each party consents to their jurisdiction.
              Mandatory consumer protections in your country of residence remain unaffected.
            </p>

            <h2 className="heading-md text-foreground pt-4">Changes</h2>
            <p>
              We may update these Terms as the service changes. Material changes will be communicated by
              reasonable means. Continued use after updated Terms take effect means you accept them.
            </p>

            <h2 className="heading-md text-foreground pt-4">Contact</h2>
            <p>
              Questions about these Terms may be sent to{" "}
              <a href="mailto:support@antatlas.ai">support@antatlas.ai</a>.
            </p>
          </div>
        </div>
      </section>

      <FooterCTA />
    </div>
  </div>
);

export const head = {
  title: "Terms of Use — AntAtlas",
  description: "Terms governing access to and use of AntAtlas services.",
  path: "/terms",
};

export default Terms;
